import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {deleteVideoPlayer, listVideoPlayerDetails, updateVideoPlayerDetails} from '../actions/videoPlayerActions';
import Loader from '../components/Loader';
import Message from '../components/Message';
import {Button, Col, Form, Modal, Row, Tab, Tabs} from 'react-bootstrap';
import {VIDEO_PLAYER_DELETE_RESET, VIDEO_PLAYER_UPDATE_DETAILS_RESET} from '../constants/videoPlayerConstants';
import './PlayerScreen_autcomplete.css';
import {listTags} from '../actions/tagActions';
import {Link} from 'react-router-dom';
import Select from "react-select";
import {listVideoCampaigns} from "../actions/videoCampaignActions";
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import CreatableSelect from "react-select/creatable";
import BusinessHoursTable from "../components/BusinessHoursTable";

const VideoPlayerScreen = ({match, history, language, t}) => {
    const dispatch = useDispatch();
    const videoPlayerId = match.params.id;

    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;

    const videoPlayerDetails = useSelector(state => state.videoPlayerDetails);
    const {loading, videoPlayer, error} = videoPlayerDetails;

    const tagList = useSelector(state => state.tagList);
    const {loading: tagsLoading, error: tagsError, tags: userTags, success: userTagSuccess} = tagList;

    const videoCampaignsList = useSelector(state => state.videoCampaignList);
    const {loading: videoCampaignsLoading, error: videoCampaignsError, videoCampaignList, success: videoCampaignListSuccess} = videoCampaignsList;

    const videoPlayerUpdateDetails = useSelector(state => state.videoPlayerUpdateDetails);
    const {success} = videoPlayerUpdateDetails;

    const videoPlayerDelete = useSelector(state => state.videoPlayerDelete);
    const {success: deleteSuccess, loading: deleteLoading, error: deleteError} = videoPlayerDelete;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [description, setDescription] = useState('');
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');
    const [address, setAddress] = useState('');
    const [tags, setTags] = useState([]);

    const [suggestions, setSuggestions] = useState([]);
    const [videoCampaigns, setVideoCampaigns] = useState([]);
    const [videoCampaignOptions, setVideoCampaignOptions] = useState([]);

    const [show, setShow] = useState(false);

    const [businessHours, setBusinessHours] = useState(null);
    const [generalHours, setGeneralHours] = useState({
        from: '06:00',
        to: '18:00',
        open: true,
    });

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [history, userInfo]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(()=> {
        //console.log('dispatch list video campaigns');
        dispatch(listVideoCampaigns());
    },[]);

    useEffect(()=>{
        if(videoCampaignList){
            //console.log(videoCampaignList);
            const idk = videoCampaignList.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setVideoCampaignOptions(idk);
        }
    },[dispatch, videoCampaignList]);

    useEffect(() => {
        if (!videoPlayer || !videoPlayer.name || success || videoPlayer._id !== videoPlayerId) {
            dispatch({type: VIDEO_PLAYER_UPDATE_DETAILS_RESET});
            dispatch(listVideoPlayerDetails(match.params.id));
        } else {
            setName(videoPlayer.name);
            setEmail(videoPlayer.email);
            setDescription(videoPlayer.description);
            setCountry(videoPlayer.country);
            setCity(videoPlayer.city);
            setZip(videoPlayer.zip);
            setAddress(videoPlayer.address);
            videoPlayer.videoCampaigns = videoPlayer.videoCampaigns.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setVideoCampaigns(videoPlayer.videoCampaigns);
            //console.log("setting businesshours");
            if(videoPlayer.businessHours !== undefined && videoPlayer.businessHours.length !== 0) {
                //console.log("businesshours NOT undefined");
                //console.log(videoPlayer.businessHours);
                setBusinessHours(videoPlayer.businessHours);
            }
            else {
                //console.log("businesshours ARE undefined");
                setBusinessHours([
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    },
                    {
                        from: '06:00',
                        to: '18:00',
                        open: true,
                    }
                ]);
            }
            if(videoPlayer.tags){
                setTags(() =>
                    videoPlayer.tags.map((tgs) => {
                        tgs.label = tgs.name;
                        tgs.value = tgs._id;
                        return tgs;
                    })
                );
            }
        }

    }, [dispatch, match, videoPlayer, videoPlayerId]);

    useEffect(() => {
        if (!userTagSuccess || success) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
        }

    }, [userTagSuccess, dispatch]);

    /*useEffect(()=>{
        if(!videoCampaignListSuccess || success){
            dispatch(listVideoCampaigns());
        }
        else {
            setVideoCampaignOptions(videoCampaignList);
        }
    }, [videoCampaignListSuccess, dispatch]);*/

    const deleteVideoPlayerHandle = async () => {
        dispatch(deleteVideoPlayer(videoPlayer));
        setShow(false);
    };

    useEffect(() => {
        if (deleteSuccess) {
            history.push('/video_players');
            dispatch({type: VIDEO_PLAYER_DELETE_RESET});
        } else {
            dispatch({type: VIDEO_PLAYER_DELETE_RESET});
        }
    }, [deleteSuccess, dispatch, history]);

    const onVideoCampaignsSelected = (videoCampaignsFromSelect) => {
        setVideoCampaigns(videoCampaignsFromSelect);
    }

    const submitHandler = (e) => {
        e.preventDefault();
        const properCampaigns = videoCampaigns.map(element => {
            let {label,value,...rest} = element;
            return rest;
        });

        dispatch(updateVideoPlayerDetails({
            _id: videoPlayer._id,
            name,
            email,
            description,
            country,
            city,
            zip,
            address,
            businessHours,
            tags,
            videoCampaigns :properCampaigns,
        }));
    };

    const handleClose = () => setShow(false);

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('button_delete')}: {videoPlayer.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('video_player_delete_confirmation')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('button_cancel')}
                    </Button>
                    <Button variant="danger" onClick={deleteVideoPlayerHandle}>{t('button_delete')}</Button>
                </Modal.Footer>
            </Modal>

            <ThreeColumnRow firstColumn={<Link to='/video_players' className='btn btn-info m-0 p-2'>{t('button_back')}</Link>} secondColumn={t('video_player_data_text')} thirdColumn={<div className='btn btn-danger m-0 p-2' onClick={() => setShow(true)}>{t('button_delete')}</div>}/>

            {(loading || tagsLoading || deleteLoading) ? (<Loader/>) : (error || tagsError || deleteError) ? (
                <Message variant='danger'>{error ? error : tagsError ? tagsError : deleteError}</Message>) : (
                <>
                    {success && <Message variant='success'>{t('video_player_updated')}</Message>}
                    <Tabs defaultActiveKey="details" id="uncontrolled-tab-example">
                        <Tab eventKey="details" title={t('video_player_data')}>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                }}
                                autoComplete='off'
                                className='mt-3'>
                                <Row>
                                    <Col sm={12} md={6}>
                                        <Form.Group controlId='name'>
                                            <Form.Label>{t('video_player_name')}</Form.Label>
                                            <Form.Control
                                                type='name'
                                                placeholder={t('video_player_name_description')}
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId='email'>
                                            <Form.Label>{t('video_player_email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                placeholder={t('video_player_email_description')}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId='description'>
                                            <Form.Label>{t('video_player_description')}</Form.Label>
                                            <Form.Control
                                                type='description'
                                                placeholder={t('video_player_description_description')}
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group controlId='tags'>
                                            <Form.Label>{t('video_player_tags')}</Form.Label>
                                            <CreatableSelect
                                                isMulti
                                                isSearchable
                                                isClearable
                                                formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                                onChange={(newTag) => {
                                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                                        newTag = temporaryTag;
                                                    }
                                                    //console.log(newTag);
                                                    setTags(newTag);
                                                }}
                                                onCreateOption={(newTag) => {
                                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                                        newTag = temporaryTag;
                                                    }
                                                    else {
                                                        newTag = {
                                                            id: undefined,
                                                            label: newTag,
                                                            value: newTag,
                                                            name: newTag
                                                        }
                                                    }
                                                    //console.log(newTag);
                                                    setTags([...tags, newTag]);
                                                }}
                                                options={suggestions}
                                                value={tags}
                                                placeholder={t('video_player_tags_description')}
                                                className='react-select-container'
                                                classNamePrefix='react-select'
                                            />
                                            {/*<ReactTags allowNew={true}
                                                       placeholderText={t('videoPlayer_tags_description')}
                                                       allowBackspace={false}
                                                       onDelete={(idx) => {
                                                           const newTags = tags.slice(0);
                                                           newTags.splice(idx, 1);
                                                           setTags(newTags);
                                                       }}
                                                       onAddition={(newTag) => {
                                                           const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                           if(temporaryTag !== null && temporaryTag !== undefined){
                                                               newTag = temporaryTag;
                                                           }
                                                           //console.log(newTag);
                                                           setTags([...tags, newTag]);
                                                       }}
                                                       suggestions={suggestions}
                                                       tags={tags}

                                            />*/}
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <Form.Group controlId='country'>
                                            <Form.Label>{t('video_player_country')}</Form.Label>
                                            <Form.Control
                                                type='country'
                                                placeholder={t('video_player_country_description')}
                                                value={country}
                                                onChange={(e) => setCountry(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId='city'>
                                            <Form.Label>{t('video_player_city')}</Form.Label>
                                            <Form.Control
                                                type='city'
                                                placeholder={t('video_player_city_description')}
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId='zip'>
                                            <Form.Label>{t('video_player_zip')}</Form.Label>
                                            <Form.Control
                                                type='zip'
                                                placeholder={t('video_player_zip_description')}
                                                value={zip}
                                                onChange={(e) => setZip(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId='address'>
                                            <Form.Label>{t('video_player_address')}</Form.Label>
                                            <Form.Control
                                                type='address'
                                                placeholder={t('video_player_address_description')}
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Tab>
                        <Tab eventKey="schedule" title={t('player_open_times')}>
                            {businessHours ? <BusinessHoursTable days={[
                                t('monday'),
                                t('tuesday'),
                                t('wednesday'),
                                t('thursday'),
                                t('friday'),
                                t('saturday'),
                                t('sunday'),
                            ]} businessHours={businessHours} setBusinessHours={setBusinessHours}
                                                                 generalHours={generalHours}
                                                                 setGeneralHours={setGeneralHours}
                                                                 language={language}
                                                                 t={t}
                            /> : null}
                        </Tab>
                        <Tab eventKey="videoCampaigns" title={t('video_player_video_campaigns')}>
                            {/* outside div added with the videoCampaigns as key to force a re-render and display the default options properly */}
                            <div key={videoCampaigns}>
                                <Select defaultValue={videoCampaigns} options={videoCampaignOptions} isMulti  onChange={onVideoCampaignsSelected} placeholder={t('video_player_select_video_campaigns')}/>
                            </div>
                        </Tab>
                    </Tabs>

                    <Button onClick={(e) => {
                        submitHandler(e);
                    }} variant='primary' className='mt-3 p-2 d-block ml-auto mr-auto'>
                        {t('button_modify')}
                    </Button>
                </>
            )}
        </>
    );
};

export default VideoPlayerScreen;
